import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import { PendingChange } from '@/shared/config';

import { AssetID, DetectionID } from '../config';

export const groupChangesByAsset = (
  changes: PendingChange[],
  teeth: Tooth[],
) => {
  return changes.reduce((acc, change) => {
    const currentToothDetection = teeth
      .find((tooth) => tooth.ID === change.tooth.toothID)
      ?.Detections.find(
        (detection) => detection.ID === change.tooth.detectionID,
      );
    const assetID = currentToothDetection?.Localizations?.TargetAssetID;
    if (!assetID) {
      return acc;
    }

    const detectionID = change.tooth.detectionID;
    const existingAssetMap = acc.get(assetID) || new Map();
    const updatedAssetMap = new Map(existingAssetMap);
    updatedAssetMap.set(detectionID, change);

    return new Map(acc).set(assetID, updatedAssetMap);
  }, new Map<AssetID, Map<DetectionID, PendingChange>>());
};
